export interface CaseData {
  id: string
  name: string
  cover: string
  intro: string
  businessResults: string
  viewCount: number
  likeCount: number
  businessLine: string
  institution: string
  scenario: string
  keywords: string[]
  department: string
  author: string
  createdAt: string
  // 详情页内容
  background: string // 背景模板
  analysisApproach: string // 分析思路
  detailedResults: string // 详细业务成效
  templateLink?: string // 关联的报表模板名称
  templateId?: string // 关联的报表模板ID
}

export const CASES_DATA: CaseData[] = [
  {
    id: 'case-001',
    name: '代发客群精准营销与留存提升',
    cover: 'case-cover-1',
    intro: '通过透视分析代发客户工资流水、余额变动、转出行为等数据，识别低留存客群特征，指导网点开展针对性走访营销，有效提升代发客户留存率。',
    businessResults: '代发客户月度留存率从 9% 提升至 21%，当月累计代发工资金额留存占比提升 12 个百分点，带动 AUM 增长超 800 万元。',
    viewCount: 1286,
    likeCount: 156,
    businessLine: '零售业务',
    institution: '总行',
    scenario: '营销推动',
    keywords: ['代发客群', '精准营销', '客户留存', '工资代发', '存款余额', '代发'],
    department: '零售金融部',
    author: '张三',
    createdAt: '2024-03-15',
    background: '部分代发工资客户在工资到账后短时间内将资金转出至他行，留存率仍有提升空间。传统"广撒网"式营销成本高、针对性弱，亟需通过数据分析识别关键流失特征，指导一线网点精准施策。',
    analysisApproach: '1. 通过"代发客群营销分析"报表，筛选查询年月为 2026 年 5 月、存款时点余额≥1000 元的代发客户清单\n2. 按"当月累计代发工资金额"与"当月累计转出金额"对比，计算各客户资金留存比例\n3. 按代发单位、开户网点两个维度分组统计，识别留存率偏低的单位和网点\n4. 对客户姓名逐条查看，筛选转出金额占比超过 70% 的客户作为重点跟进对象\n5. 将清单下发至对应网点，由客户经理逐户电话回访或上门走访，了解资金去向和客户需求\n6. 针对客户反馈集中问题（如他行理财收益更高、转账手续费优惠等），制定差异化挽留方案：推荐我行理财产品、开通手续费减免、提供专属存款产品\n7. 次月重复跑报表对比留存率变化，跟踪营销效果',
    detailedResults: '专项活动开展后三个月内：代发客户月度留存率从 9% 提升至 21%，资金留存占比（留存金额/代发金额）从 25% 提升至 37%。其中，东风支行通过逐户走访，将本单位代发客户留存率从 6% 提升至 18%；通过推荐"随鑫存"专属存款产品，锁定代发资金约 500 万元；客户回访覆盖率达 92%，客户满意度评分提升 8 分。全行代发客群带动 AUM 环比增长超 800 万元。',
    templateLink: '代发客群营销分析',
    templateId: '11',
  },
  {
    id: 'case-002',
    name: '对公大额存款变动每日跟进与督导考核',
    cover: 'case-cover-2',
    intro: '基于对公大额存款变动日报，建立"日监测-日通报-日跟进"机制，对大额存款流出实行 T+1 跟进、限时反馈，有效挽回存款流失。',
    businessResults: '大额存款流出挽回率达 16%，月度对公存款净增由负转正，挽回潜在存款损失超 8000 万元。',
    viewCount: 956,
    likeCount: 128,
    businessLine: '对公业务',
    institution: '总行',
    scenario: '营销推动',
    keywords: ['对公存款', '每日跟进', '督导考核', '存款挽留', '存款余额', '大额'],
    department: '公司金融部',
    author: '李四',
    createdAt: '2024-05-20',
    background: '对公大额存款波动频繁，单笔流出金额大、影响面广。过去往往等到月末才发现存款大幅下降，错过最佳挽留时机。需要建立每日监测、快速响应机制，将存款流失风险降到最低。',
    analysisApproach: '1. 通过"对公大额存款变动"报表，设置筛选条件：余额变动金额≥1000 万元，每日定时导出变动清单\n2. 区分"流入"与"流出"两类，重点关注流出客户——对比上期余额与本期余额，计算变动幅度\n3. 按客户名称、开户机构、管户客户经理三个维度归类，每笔流出明确责任人\n4. 建立"日通报"机制：每日上午 10 点前将前一日变动清单推送至各支行行长和客户经理工作群\n5. 建立"T+1 跟进"要求：客户经理须在收到清单后 24 小时内联系客户，了解资金流出原因，填写跟进反馈表（流出原因、客户诉求、挽留措施、预计效果）\n6. 对单笔流出超 5000 万元的，由支行行长或分行对公部负责人亲自带队上门拜访\n7. 建立周考核机制：每周统计各支行挽回率（成功挽留金额/流出总金额），在分行经营分析会上通报排名，连续两周排名末位的支行约谈负责人\n8. 对挽留成功的案例提炼经验做法，在全行推广',
    detailedResults: '机制运行三个月内：全行对公大额存款流出挽回率从 15% 提升至 42%，月度对公存款净增由上月减少 2.3 亿元转为净增 1.1 亿元。其中，某制造企业因他行贷款利率优惠拟转出 8000 万元存款，客户经理当日获知后迅速上报，分行对公部负责人第二天带队上门，通过"存款+贷款"综合方案成功挽留；某房地产企业因项目结算需转出 6000 万元，经了解资金用途后推荐我行监管账户服务，保留 4000 万元在我行账户体系。全行累计挽回潜在存款损失超 8000 万元，客户经理主动营销意识显著增强。',
    templateLink: '对公大额存款变动',
    templateId: '1',
  },
  {
    id: 'case-003',
    name: '掌上银行客户活跃度分析与运营提升',
    cover: 'case-cover-3',
    intro: '通过统计掌上银行客户登录频次、功能使用偏好、交易转化路径等数据，识别沉默客户和低活跃客群，制定针对性运营策略提升活跃度和业务转化率。',
    businessResults: '掌上银行月活客户数提升 38%，重点功能使用率提升 52%，移动端业务办理占比从 31% 提升至 49%。',
    viewCount: 1105,
    likeCount: 142,
    businessLine: '零售业务',
    institution: '总行',
    scenario: '流程优化',
    keywords: ['掌上银行', '客户活跃', '移动端运营', '功能转化'],
    department: '网络金融部',
    author: '王五',
    createdAt: '2024-07-22',
    background: '我行掌上银行注册用户已突破 120 万，但月活跃客户占比不足 35%，大量客户下载后仅使用查询功能或长期不登录。移动端作为低成本服务渠道，其活跃度直接影响网点柜面压力和客户体验。亟需通过数据分析找出活跃度低的原因，制定有针对性的运营策略。',
    analysisApproach: '1. 按客户近 90 天登录次数、停留时长、使用功能类型三个维度进行分组统计，将客户划分为"高频活跃"（月登录≥8次）、"中频一般"（月登录 3-7 次）、"低频沉默"（月登录≤2次）三类\n2. 分析各客群的功能使用偏好：高频客户以转账缴费、理财购买为主，低频客户以余额查询、明细查询为主\n3. 梳理高频功能的转化路径：从首页到目标功能需要几步点击，是否存在路径过长、入口不明显的问题\n4. 按年龄、开户机构两个维度交叉分析，发现 50 岁以上客户和县域网点客户的活跃度显著低于平均水平\n5. 将沉默客户清单按管户网点下发，由客户经理通过短信推送、电话回访等方式引导客户重新使用\n6. 针对老年客群和县域客群，制作简版操作指南图文和短视频，通过微信公众号和网点厅堂投放\n7. 每月重复跑报表跟踪活跃度变化，按周统计运营活动效果',
    detailedResults: '专项运营活动开展后三个月内：掌上银行月活跃客户数从 38 万提升至 52 万，提升幅度 38%。其中，低频沉默客户转化率（转为中频及以上）达 18%，50 岁以上客户月活占比从 12% 提升至 21%。转账缴费功能使用率从 28% 提升至 45%，理财购买功能使用率从 9% 提升至 16%。移动端业务办理笔数占全行业务总量的比例从 31% 提升至 49%，对应减少柜面业务量约 4.2 万笔/月，相当于释放了 6 个网点的人力。客户对掌上银行的满意度评分从 3.6 分提升至 4.1 分（满分 5 分）。',
    templateLink: '掌上银行运营分析',
    templateId: '',
  },
]

export const BUSINESS_LINES = ['全部', '零售业务', '对公业务', '金融市场', '风险合规', '财务会计', '运营管理', '其他']
export const CASE_SCENARIOS = ['业绩考核', '营销推动', '网点产能', '流程优化', '风险合规']
